
import { Entity, Field } from 'typegraph';
import GroupDiscountData from 'panels/bundleEntries/entities/GroupDiscountData';
import autobind from 'autobind-decorator';
import Organization from 'panels/organizations/entities/Organization';
import { ID } from 'common/form/fields/entitySelect/IEntitySelect';

export default class OrganizationSeatDistribution {

    @Field()
    public id: ID;

    @Field({entity: Organization})
    public organization:Organization

    @Field()
    public enrollLimit: number;

    @Field()
    public enrollCount: number;

    @Field()
    public openAccess: boolean;
    
}





// WEBPACK FOOTER //
// ./src/panels/checkout/entities/OrganizationSeatDistribution.ts